import { query } from '@confluence/query-preloader-tools';

import { GetProductsTeamAndSpaceQuery } from './GetProductsTeamAndSpaceQuery.graphql';

export const preloadProductsTeamAndSpaceQuery = () => {
	return query({
		query: GetProductsTeamAndSpaceQuery,
	});
};
